// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";

export const printOptionSelector = (state: ApplicationState) => {
    return toToolkitApplicationState(state).bunzl.components.orderDetailsTotal.hidePriceOnPrint;
};
